export default __webpack_public_path__ + "media/images/community/wordmark-light-14cb35cacf2c319196f81badf153805d.svg";